import axios from 'axios'
import store from '../store/'
import router from '../router/'

axios.defaults.withCredentials = true
axios.defaults.baseURL = process.env.API_ROOT_URL

let isRequesting = false
let timer
let generateTimer = () => {
  document.getElementById('globalLoading').style.display = 'flex'

  clearTimeout(timer)
  timer = setTimeout(() => {
    !isRequesting && (document.getElementById('globalLoading').style.display = 'none')
    timer = null
  }, 500)
}
axios.interceptors.request.use(req => {
  isRequesting = true
  generateTimer()
  return req
}, (error) => {
  document.getElementById('globalLoading').style.display = 'none'
  console.log(error)
})
axios.interceptors.response.use(response => {
  if (!isRequesting || timer === null) document.getElementById('globalLoading').style.display = 'none'
  isRequesting = false
  return response
},
(error) => {
  (document.getElementById('globalLoading').style.display = 'none')
  if (error.message === 'Network Error' && store.state.previousRoute.name !== '503' && router.currentRoute.name !== '503') {
    store.state.enumData = null
    router.push({name: '503'})
  } else if (error.response.status === 403) {
    router.push({name: '403'})
  }
  // this.$store.commit('setHttpError', error.toJSON(), {root: true})
  return Promise.reject(error.response)
})

export default{
  async  getEnum () {
    return (await axios.get('/public/enum')).data
  },
  // user
  async updateMe (user) {
    await axios.patch('/user', user, {interceptorsException: true})
  },
  async updateMember (member) {
    await axios.patch(`/member/${member._id}`, member)
  },
  async login (user) {
    return (await axios.post('/auth/login', user)).data
  },
  async authentication () {
    return (await axios.get('/auth/authentication')).data
  },
  async logout () {
    return (await axios.post('/auth/logout', null, {interceptorsException: true})).data
  },
  async getBidList () {
    return (await axios.get('/user/me/bids')).data
  },
  async getIdentityInProject (projectId) {
    return (await axios.post('/auth/get-identity-in-project', {belongTo: projectId}, {interceptorsException: true})).data
  },
  // Subscriber / Subscription
  async addSubscription (user) {
    await axios.post('/subscription', user)
  },
  async getSubscribers () {
    return (await axios.get('/subscriptions')).data
  },
  async getSubscription (id) {
    const result = await axios.get(`/subscription/${id}`)
    return result.data
  },
  async updateSubscription (subscription) {
    await axios.patch(`/subscription/${subscription._id}`, subscription)
  },
  async deleteSubscription (id) {
    await axios.delete(`/subscription/${id}`)
  },
  async getSubscriberMember (subscriberId) {
    return (await axios.get('/subscriber/my/members')).data
  },
  async deleteSubscriberMember (memberIds) {
    await axios.delete('/subscriber/my/members', {data: memberIds, interceptorsException: true})
  },
  async getInvitationMemberLink (subscription) {
    return (await axios.post('/invitation/subscription-member', {subscription}, {interceptorsException: true})).data
  },
  async getInvitationSubscriberLink (subscription) {
    return (await axios.post('/invitation/subscriber', {subscription})).data
  },

  // BidPayItems
  async addBid (data) {
    return (await axios.post(`/user/bid`, data)).data
  },
  async uploadBidPayItems (_id, file) {
    return (await axios.put(`/user/bid/${_id}/pay-items`, file)).data
  },
  async updateBid (_id, data) {
    return (await axios.patch(`/user/bid/${_id}`, data)).data
  },
  async getBid (_id) {
    return (await axios.get(`/user/bid/${_id}`)).data
  },
  async patchBidPayItems (bidId, payItemId, price) {
    return (await axios.patch(`/user/bid/${bidId}/pay-item/${payItemId}`, {price})).data
  },
  async deleteBid (_id) {
    return (await axios.delete(`/user/bid/${_id}`)).data
  },
  async getBidComparison (_id) {
    return (await axios.get(`/user/bid/${_id}/comparison`)).data
  },

  // project
  async getProjects (year, type) {
    if (year === 'All' || year === undefined) return (await axios.get('/projects', {params: {type}})).data
    else return (await axios.get('/projects', {params: {year, type}})).data
  },
  async getSubscriberProjects (subscriptionId) {
    return (await axios.get(`/subscription/${subscriptionId}/projects`)).data
  },
  async getProject (projectId) {
    return (await axios.get(`/project/${projectId}`)).data
  },
  async addProject (condition) {
    return (await axios.post('/project', condition)).data
  },
  async addProgressReport (projectId, data) {
    return (await axios.post(`/project/${projectId}/report/progress`, data, {responseType: 'arraybuffer'})).data
  },
  async addPayRecord (projectId, data) {
    return (await axios.post(`/project/${projectId}/invoice`, data)).data
  },
  async addInvoiceImageMeta (projectId, invoiceId, meta) {
    return (await axios.post(`/project/${projectId}/invoice/${invoiceId}/image`, meta)).headers
  },
  async addInvoiceImageContent (url, data) {
    await axios.put(url, data)
  },
  async downloadPayRecord (projectId, payRecordId) {
    return (await axios.post(`/project/${projectId}/invoice/${payRecordId}/download`, null, {responseType: 'arraybuffer'})).data
  },
  async getProgressReports (projectId) {
    return (await axios.get(`/project/${projectId}/report/progress`)).data
  },
  async getProgressReport (projectId, _id) {
    return (await axios.get(`/project/${projectId}/report/progress/${_id}`)).data
  },
  async downloadProgressReport (projectId, ids) {
    return (await axios.post(`/project/${projectId}/report/progress/download`, ids, {responseType: 'arraybuffer'})).data
  },
  async deleteProgressReport (projectId, _id) {
    return (await axios.delete(`/project/${projectId}/report/progress/${_id}`)).data
  },
  async getPayRecords (projectId) {
    return (await axios.get(`/project/${projectId}/invoice`)).data
  },
  async updatePayRecordTotalCost (projectId, _id, cost) {
    await await axios.patch(`project/${projectId}/invoice-record/${_id}/cost`, cost)
  },
  async updatePayRecord (projectId, payRecord) {
    await axios.patch(`project/${projectId}/invoice-record/${payRecord._id}`, payRecord)
  },
  async approvedPayRecord (projectId, _id) {
    await axios.patch(`project/${projectId}/invoice-record/${_id}/approved`)
  },
  async getPayRecord (projectId, _id) {
    return (await axios.get(`/project/${projectId}/invoice/${_id}`)).data
  },
  async deletePayRecord (projectId, _id) {
    return (await axios.delete(`/project/${projectId}/invoice/${_id}`)).data
  },
  async deleteProject (projectId) {
    return (await axios.delete(`/project/${projectId}`)).data
  },
  async deleteMemberFromProject (memberId) {
    await axios.delete(`/member/${memberId}`)
  },
  async updateProject (projectId, condition) {
    return (await axios.patch(`/project/${projectId}`, condition)).data
  },
  async getProjectProgressDate (projectId, currentDate, isActual = true) {
    return (await axios.get(`/project/${projectId}/progress/${currentDate}?isActual=${isActual}`)).data
  },
  async getManMachineItems (projectId, condition) {
    return (await axios.get(`/project/${projectId}/man-machine-items`, {params: condition})).data
  },
  async uploadDailyRecordTemplate (projectId, {mime, name, file}) {
    const result = await axios.post(`/project/${projectId}/template/daily-record`, {mime, name})
    return (await axios.put(result.headers['location'], file, {
      headers: {
        'Content-Type': mime
      }
    })).data
  },
  async deleteDailyRecordTemplate (projectId, fileId) {
    return (await axios.delete(`/project/${projectId}/template/daily-record/${fileId}`)).data
  },
  async selectedDailyRecordTemplate (projectId, templateId) {
    return (await axios.patch(`/project/${projectId}/template/daily-record/${templateId}/selected`)).data
  },
  async uploadDailyPayItemsTemplate (projectId, {mime, name, file}) {
    const result = await axios.post(`/project/${projectId}/template/daily-pay-items`, {mime, name})
    return (await axios.put(result.headers['location'], file, {
      headers: {
        'Content-Type': mime
      }
    })).data
  },
  async deleteDailyPayItemsTemplate (projectId, fileId) {
    return (await axios.delete(`/project/${projectId}/template/daily-pay-items/${fileId}`)).data
  },
  async selectedDailyPayItemsTemplate (projectId, templateId) {
    return (await axios.patch(`/project/${projectId}/template/daily-pay-items/${templateId}/selected`)).data
  },
  async uploadInspectionListTemplate (projectId, {mime, name, file}) {
    const result = await axios.post(`/project/${projectId}/template/inspection-list`, {mime, name})
    return (await axios.put(result.headers['location'], file, {
      headers: {
        'Content-Type': mime
      }
    })).data
  },
  async deleteInspectionListTemplate (projectId, fileId) {
    return (await axios.delete(`/project/${projectId}/template/inspection-list/${fileId}`)).data
  },
  async selectedInspectionListTemplate (projectId, templateId) {
    return (await axios.patch(`/project/${projectId}/template/inspection-list/${templateId}/selected`)).data
  },
  async uploadErrorRecordTemplate (projectId, {mime, name, file}) {
    const result = await axios.post(`/project/${projectId}/template/error-record`, {mime, name})
    return (await axios.put(result.headers['location'], file, {
      headers: {
        'Content-Type': mime
      }
    })).data
  },
  async deleteErrorRecordTemplate (projectId, fileId) {
    return (await axios.delete(`/project/${projectId}/template/error-record/${fileId}`)).data
  },
  async selectedErrorRecordTemplate (projectId, templateId) {
    return (await axios.patch(`/project/${projectId}/template/error-record/${templateId}/selected`)).data
  },
  async uploadErrorRecordListTemplate (projectId, {mime, name, file}) {
    const result = await axios.post(`/project/${projectId}/template/error-record-list`, {mime, name})
    return (await axios.put(result.headers['location'], file, {
      headers: {
        'Content-Type': mime
      }
    })).data
  },
  async deleteErrorRecordListTemplate (projectId, fileId) {
    return (await axios.delete(`/project/${projectId}/template/error-record-list/${fileId}`)).data
  },
  async selectedErrorRecordListTemplate (projectId, templateId) {
    return (await axios.patch(`/project/${projectId}/template/error-record-list/${templateId}/selected`)).data
  },
  async uploadReviewApplicationTemplate (projectId, {mime, name, file}) {
    const result = await axios.post(`/project/${projectId}/template/review-application`, {mime, name})
    return (await axios.put(result.headers['location'], file, {
      headers: {
        'Content-Type': mime
      }
    })).data
  },
  async deleteReviewApplicationTemplate (projectId, fileId) {
    return (await axios.delete(`/project/${projectId}/template/review-application/${fileId}`)).data
  },
  async selectedReviewApplicationTemplate (projectId, templateId) {
    return (await axios.patch(`/project/${projectId}/template/review-application/${templateId}/selected`)).data
  },
  async uploadTestRecordTemplate (projectId, {mime, name, file}) {
    const result = await axios.post(`/project/${projectId}/template/test-record`, {mime, name})
    return (await axios.put(result.headers['location'], file, {
      headers: {
        'Content-Type': mime
      }
    })).data
  },
  async deleteTestRecordTemplate (projectId, fileId) {
    return (await axios.delete(`/project/${projectId}/template/test-record/${fileId}`)).data
  },
  async selectedTestRecordTemplate (projectId, templateId) {
    return (await axios.patch(`/project/${projectId}/template/test-record/${templateId}/selected`)).data
  },
  async getProjectInfo (projectId) {
    return (await axios.get(`/public/project/${projectId}/info`)).data
  },
  async getMembers (projectId) {
    return (await axios.get(`/project/${projectId}/members`)).data
  },
  async deleteBillboard (projectId) {
    await axios.delete(`/project/${projectId}/billboard`)
  },
  async updateBillboard (projectId, image) {
    const { location } = (await axios.post(`/project/${projectId}/billboard`, {extension: image.file.name.split('.').pop()})).headers
    await axios.put(location, image.file)
  },
  // Sheet
  async getSheets (parentId) {
    return (await axios.get(`/project/${parentId}/sheets`)).data
  },
  async getSheetPayItems (sheetId) {
    return (await axios.get(`/project/${sheetId}/sheet-pay-items`)).data
  },
  async updateSheetPayItems ({sheetId, payItemIds}) {
    await axios.put(`/project/${sheetId}/sheet-pay-items`, payItemIds)
  },
  async updateSheetPayItem ({sheetId, payItem}) {
    await axios.patch(`/project/${sheetId}/sheet-pay-item/${payItem._id}`, payItem)
  },
  // testRecord
  async getTestRecordTodo (projectId) {
    return (await axios.get(`/project/${projectId}/test-record-todo`)).data
  },

  // DailyRecord
  async getDailyRecords (projectId, filterOptions) {
    return (await axios.get(`/project/${projectId}/daily-records`, {params: filterOptions})).data
  },
  async getDailyRecord (dailyRecordId) {
    return (await axios.get(`/daily-record/${dailyRecordId}`)).data
  },
  async addDailyRecord (condition) {
    const result = await axios.post('/daily-record', condition)
    if (result.status === 409) {
      return this.$VXETable.modal.alert({
        status: 'error',
        content: '此填報日期已新增日誌！',
        title: '操作停止',
        confirmButtonText: '好',
        draggable: false
      })
    }
    return result.data
  },
  async updateDailyRecord (dailyRecordId, condition) {
    return (await axios.patch(`/daily-record/${dailyRecordId}`, condition)).data
  },
  async deleteDailyRecord (dailyRecordId) {
    return (await axios.delete(`/daily-record/${dailyRecordId}`)).data
  },
  async getPayItems (projectId, condition) {
    return (await axios.get(`/project/${projectId}/pay-items`, {params: condition})).data
  },
  async getSheetDiffPayItems (projectId, sheetIds) {
    return (await axios.get(`/project/${projectId}/selected-sheet-pay-items`, {params: {selectedSheets: sheetIds}})).data
  },
  async downloadDailyRecord (dailyRecordId) {
    try {
      return (await axios.post(`daily-record/${dailyRecordId}/download`, null, {responseType: 'arraybuffer'})).data
    } catch (error) {
      throw new Error('下載失敗！')
    }
  },
  async downloadDailyPayItems (dailyRecordId) {
    try {
      return (await axios.post(`daily-record/${dailyRecordId}/pay-items/download`, null, {responseType: 'arraybuffer'})).data
    } catch (error) {
      throw new Error('下載失敗！')
    }
  },
  async downloadDailyRecords (dailyRecordIds) {
    try {
      return (await axios.post(`daily-records/download`, dailyRecordIds, {responseType: 'arraybuffer'})).data
    } catch (error) {
      throw new Error('下載失敗！')
    }
  },
  // Schedule
  async getSchedule (projectId, isActual) {
    return (await axios.get(`/project/${projectId}/progress?isActual=${isActual}`)).data
  },
  async addSchedule (projectId, condition) {
    return (await axios.post(`/project/${projectId}/progress-changed`, condition)).data
  },
  async getProgressChangeList (projectId) {
    return (await axios.get(`/project/${projectId}/progress-changed`)).data
  },
  async getProgressChange (projectId, progressChangedId) {
    return (await axios.get(`/project/${projectId}/progress-changed/${progressChangedId}`)).data
  },
  async updateProgressChange (projectId, progressChangedId, progress) {
    return (await axios.patch(`/project/${projectId}/progress-changed/${progressChangedId}`, {progress: progress})).data
  },
  async deleteSchedule (projectId, progressChangedId) {
    await axios.delete(`/project/${projectId}/progress-changed/${progressChangedId}`)
  },

  // Contract
  async addContractChanged (projectId, contract) {
    await axios.post(`/project/${projectId}/contract-changed`, contract)
  },
  async updateContractChanged (projectId, _id, contract) {
    await axios.patch(`/project/${projectId}/contract-changed/${_id}`, contract)
  },
  async approveContractChanged (projectId, _id, approvedAt) {
    await axios.patch(`/project/${projectId}/contract-changed/${_id}/approved`, {approvedAt})
  },
  async deleteContractChanged (projectId, _id) {
    await axios.delete(`/project/${projectId}/contract-changed/${_id}`)
  },
  async getContractChanged (projectId, _id) {
    return (await axios.get(`/project/${projectId}/contract-changed/${_id}`)).data
  },
  async getContracts (projectId) {
    return (await axios.get(`/project/${projectId}/contracts`)).data
  },
  async convertXMLToPayItems (xmlFile) {
    return (await axios.post('/pay-items/convert-xml', xmlFile)).data
  },

  // InspectionType
  async addInspectionType (inspection) {
    if (!inspection.project) throw new Error('need project')

    return (await axios.post('inspection-type', inspection)).data
  },
  async copyInspectionType (inspectionId) {
    await axios.post(`inspection-type/${inspectionId}/copy`)
  },
  async updateInspectionType (inspectionType) {
    await axios.patch(`/inspection-type/${inspectionType._id}`, inspectionType)
  },
  async addInspectionTypeTemplateMeta (inspectionTypeId, meta) {
    return (await axios.post(`/inspection-type/${inspectionTypeId}/template`, meta)).headers
  },
  async addInspectionTypeTemplateContent (url, data) {
    await axios.put(url, data)
  },
  async getInspectionType (_id) {
    return (await axios.get(`/inspection-type/${_id}`)).data
  },
  async getInspectionTypes (projectId) {
    return (await axios.get(`/project/${projectId}/inspection-types`)).data
  },
  async deleteInspectionType (inspectionTypeId) {
    await axios.delete(`/inspection-type/${inspectionTypeId}`)
  },
  async testInspectionType (project, inspectionType, templateString) {
    try {
      return (await axios.post('inspection-type/download-test', {...inspectionType, project, template: templateString}, {responseType: 'arraybuffer'})).data
    } catch (error) {
      if (!(error instanceof Error && (new TextDecoder('utf-8').decode(error.data) === 'TemplateError'))) alert('樣板檔錯誤！請在檢查樣板檔以下幾點:\n1.是否與自主檢查類型的檢查系項數量一致\n2.是否有參數表以外的參數\n3.參數格式是否錯誤')
      throw error
    }
  },
  async importInspectionTypes (projectId, inspectionTypeIds) {
    return (await axios.post('/inspection-types/import', {project: projectId, ids: inspectionTypeIds})).data
  },

  // InspectionTypeForRoot
  async _addInspectionType (inspection) {
    return (await axios.post('_inspection-type', inspection)).data
  },
  async _copyInspectionType (inspectionId) {
    await axios.post(`_inspection-type/${inspectionId}/copy`)
  },
  async _updateInspectionType (inspectionType) {
    await axios.patch(`/_inspection-type/${inspectionType._id}`, inspectionType)
  },
  async _addInspectionTypeTemplateMeta (inspectionTypeId, meta) {
    return (await axios.post(`/_inspection-type/${inspectionTypeId}/template`, meta)).headers
  },
  async _addInspectionTypeTemplateContent (url, data) {
    await axios.put(url, data)
  },
  async _getInspectionType (_id) {
    return (await axios.get(`/_inspection-type/${_id}`)).data
  },
  async _getInspectionTypes (projectId) {
    return (await axios.get(`/_inspection-types`)).data
  },
  async _deleteInspectionType (inspectionTypeId) {
    await axios.delete(`/_inspection-type/${inspectionTypeId}`)
  },
  async _testInspectionType (inspectionType, templateString) {
    try {
      return (await axios.post('_inspection-type/download-test', {...inspectionType, template: templateString}, {responseType: 'arraybuffer'})).data
    } catch (error) {
      if (!(error instanceof Error && (new TextDecoder('utf-8').decode(error.data) === 'TemplateError'))) alert('樣板檔錯誤！請在檢查樣板檔以下幾點:\n1.是否與自主檢查類型的檢查系項數量一致\n2.是否有參數表以外的參數\n3.參數格式是否錯誤')
      throw error
    }
  },
  async _importInspectionTypes (projectId, inspectionTypeIds) {
    return (await axios.post('/_inspection-types/import', {project: projectId, ids: inspectionTypeIds})).data
  },

  // Inspection
  async addInspection (inspection) {
    if (!inspection.project) throw new Error('need project')

    return (await axios.post('inspection', inspection)).data
  },
  async updateInspection (inspection) {
    await axios.patch(`/inspection/${inspection._id}`, inspection)
  },
  async getInspection (_id) {
    return (await axios.get(`/inspection/${_id}`)).data
  },
  async getInspections (projectId, filterOptions) {
    return (await axios.get(`/project/${projectId}/inspections`, {params: filterOptions})).data
  },
  async addInspectionImageMeta (inspectionId, meta) {
    return (await axios.post(`/inspection/${inspectionId}/image`, meta)).headers
  },
  async addInspectionImageContent (url, data) {
    await axios.put(url, data)
  },
  async deleteInspectionImage (inspectionId, imageId) {
    await axios.delete(`/inspection/${inspectionId}/image?id=${imageId}`)
  },
  async deleteInvoiceImage (projectId, invoiceId, imageId) {
    await axios.delete(`/project/${projectId}/invoice/${invoiceId}/image?id=${imageId}`)
  },
  async downloadInspection (ids) {
    try {
      return (await axios.post('/inspection/download', ids, {responseType: 'arraybuffer'})).data
    } catch (error) {
      if (!(error instanceof Error && (new TextDecoder('utf-8').decode(error.data) === 'TemplateError'))) alert('類型樣板檔錯誤！請在檢查樣板檔以下幾點:\n1.是否與自主檢查類型的檢查系項數量一致\n2.是否有參數表以外的參數\n3.參數格式是否錯誤')
      throw error
    }
  },
  async downloadInspectionList (projectId) {
    try {
      return (await axios.post(`/project/${projectId}/inspections/download/list`, null, {responseType: 'arraybuffer'})).data
    } catch (error) {
      if (!(error instanceof Error && (new TextDecoder('utf-8').decode(error.data) === 'TemplateError'))) alert('類型樣板檔錯誤！請在檢查樣板檔以下幾點:\n1.是否與自主檢查類型的檢查系項數量一致\n2.是否有參數表以外的參數\n3.參數格式是否錯誤')
      throw error
    }
  },
  async deleteInspection (inspectionId) {
    await axios.delete(`/inspection/${inspectionId}`)
  },

  // ErrorRecord
  async addErrorRecord (errorRecord) {
    if (!errorRecord.project) throw new Error('need project')

    return (await axios.post('error-record', errorRecord)).data
  },
  async updateErrorRecord (errorRecord) {
    await axios.patch(`/error-record/${errorRecord._id}`, errorRecord)
  },
  async updateErrorRecordResult (errorRecord, result) {
    await axios.patch(`/error-record/${errorRecord._id}/result/${result.result}`, {finishedAt: result.finishedAt, no: result.no})
  },
  async getErrorRecord (_id) {
    return (await axios.get(`/error-record/${_id}`)).data
  },
  async getErrorRecords (projectId, filterOptions) {
    return (await axios.get(`/project/${projectId}/error-records`, {params: filterOptions})).data
  },
  async getErrorRecordNewestNo (projectId, unitType, type, notifiedAt) {
    return (await axios.get(`/project/${projectId}/error-record/newest-no`, {params: {type, unitType, notifiedAt}})).data
  },
  async addErrorRecordImageMeta (errorRecordId, meta) {
    return (await axios.post(`/error-record/${errorRecordId}/image`, meta)).headers
  },
  async addErrorRecordImageContent (url, data) {
    await axios.put(url, data)
  },
  async downloadErrorRecord (ids, unitType) {
    try {
      return (await axios.post(`error-records/download`, {ids, unitType}, {responseType: 'arraybuffer'})).data
    } catch (error) {
      throw new Error('下載失敗！')
    }
  },
  async downloadErrorRecordList (projectId, unitType) {
    try {
      return (await axios.post(`project/${projectId}/error-records/download/list`, {unitType}, {responseType: 'arraybuffer'})).data
    } catch (error) {
      throw new Error('下載失敗！')
    }
  },
  async deleteErrorRecord (id) {
    await axios.delete(`error-record/${id}`)
  },
  async deleteErrorRecordImage (errorRecordId, imageId) {
    await axios.delete(`/error-record/${errorRecordId}/image?id=${imageId}`)
  },

  // File
  async addFileMeta (meta) {
    if (!meta.project) throw new Error('need project')

    return (await axios.post('file', meta)).headers
  },
  async addFileContent (url, data) {
    await axios.put(url, data)
  },
  async getProjectFiles (projectId) {
    return (await axios.get(`/project/${projectId}/files`)).data
  },
  async deleteFile (_id) {
    await axios.delete(`/file/${_id}`)
  },
  async patchFile ({fileId, name}) {
    try {
      await axios.patch(`/file/${fileId}`, {name: name})
    } catch (error) {

    }
  },

  // TestRecord
  async addTestRecord (testRecord) {
    if (!testRecord.project) throw new Error('need project')

    return (await axios.post('test-record', testRecord)).data
  },
  async updateTestRecord (testRecord) {
    await axios.patch(`/test-record/${testRecord._id}`, testRecord)
  },
  async getTestRecord (_id) {
    return (await axios.get(`/test-record/${_id}`)).data
  },
  async getTestRecords (projectId) {
    return (await axios.get(`/project/${projectId}/test-records`)).data
  },
  async downloadTestRecord (projectId, items) {
    try {
      return (await axios.post(`project/${projectId}/test-records/download`, items, {responseType: 'arraybuffer'})).data
    } catch (error) {
      throw new Error('下載失敗！')
    }
  },
  async deleteTestRecord (id) {
    await axios.delete(`test-record/${id}`)
  },
  async getTestStandards (projectId) {
    return (await axios.get(`project/${projectId}/test-standards`)).data
  },
  async addTestStandard (projectId, newTestStandard) {
    await axios.post('test-standard', {project: projectId, ...newTestStandard})
  },
  async getTestStandard (testStandardId) {
    return (await axios.get(`test-standard/${testStandardId}`)).data
  },
  async updateTestStandard (testStandard) {
    await axios.patch(`test-standard/${testStandard._id}`, testStandard)
  },
  async deleteTestStandard (testStandardId) {
    await axios.delete(`test-standard/${testStandardId}`)
  },
  // ReviewApplication
  async addReviewApplication (reviewApplication) {
    if (!reviewApplication.project) throw new Error('need project')

    return (await axios.post('review-application', reviewApplication)).data
  },
  async updateReviewApplication (reviewApplication) {
    await axios.patch(`/review-application/${reviewApplication._id}`, reviewApplication)
  },
  async getReviewApplication (_id) {
    return (await axios.get(`/review-application/${_id}`)).data
  },
  async getReviewApplications (projectId) {
    return (await axios.get(`/project/${projectId}/review-applications`)).data
  },
  async downloadReviewApplication (projectId, items) {
    try {
      return (await axios.post(`project/${projectId}/review-applications/download`, items, {responseType: 'arraybuffer'})).data
    } catch (error) {
      throw new Error('下載失敗！')
    }
  },
  async deleteReviewApplication (id) {
    await axios.delete(`review-application/${id}`)
  },

  // PictureManagement
  async getImages (condition) {
    return (await axios.get('/images', {params: condition})).data
  },
  async patchImage (image) {
    await axios.patch(`/image/${image._id}`, image)
  },
  async deleteImage (image) {
    await axios.delete(`/image/${image._id}`)
  },
  async addImageMeta (meta) {
    return (await axios.post('image', meta)).headers
  },
  async addImageContent (url, data) {
    await axios.put(url, data)
  },
  async getImageTags () {
    return (await axios.get('/image/tags')).data
  }
}



// WEBPACK FOOTER //
// ./src/api/apiConfig.js